import { render, staticRenderFns } from "./Siniestro.vue?vue&type=template&id=1a7536ea&"
import script from "./Siniestro.vue?vue&type=script&lang=js&"
export * from "./Siniestro.vue?vue&type=script&lang=js&"
import style0 from "./Siniestro.vue?vue&type=style&index=0&id=1a7536ea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports